import { useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useAlvoDropdownList(filters: any) {
  return useQuery(
    [URL.PLANO_OPERACIONAL.OBTER_DROPDOWN_ALVO, filters],
    async () => {
      const { data } = await http.get(URL.PLANO_OPERACIONAL.OBTER_DROPDOWN_ALVO, {
        params: filters,
      });
      
      return data;
    },
    {
      keepPreviousData: true,
      enabled: !!filters?.OcupacaoId,
    }
  );
}

export default useAlvoDropdownList;